import React, { useContext } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import { UIContext } from '../../../Context/UIContext'

const children = {
    hidden: { opacity: 0, y: '50%' },
    show: { opacity: 1, y: 0, transition: { duration: 0.4, type: 'tween' } }
}
const childrenMob = {}

const Client = React.forwardRef(({data}, ref) => {
    const { setSelectedModal, setModalVisible, isTablet } = useContext(UIContext)

    const handleOpenModal = () => {
        const modalData = {
            title: data.name,
            image: data.logo,
            url: data.url,
            info: data.info
        }
        setSelectedModal(modalData)
        setModalVisible(true)
    }
    return (
        <motion.li
            ref={ref}
            className="mga-clients-section__grid__item"
            whileHover={{
                scale: 1.05,
                transition: { duration: 0.5 }
            }}
            variants={isTablet ? childrenMob : children}
        >
            <button
                onClick={handleOpenModal}
            >
                <img src={data.logo} alt={data.name} />
            </button>
        </motion.li>
    )
})
const MotionClient = motion(Client)

export default MotionClient